import React, { useState } from "react";

export default function InputHolder({ input, onUpdate, value = "" }: any) {
  const [hasInput, setHasInput] = useState(value !== "");
  const inputId = input.id ? String(input.id) : input.name;

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Update the state based on whether there is input
    setHasInput(event.target.value !== "");
    onUpdate(event.target.name , event.target.value);
  };

  return (
    <div className="relative w-full sm:px-4 group" suppressHydrationWarning>
      <label
        htmlFor={inputId}
        className={`absolute top-0 bottom-0 left-7 md:left-12 m-auto h-fit origin-top-left opacity-70 duration-300 pointer-events-none text-white group-focus-within:opacity-100 group-focus-within:scale-[0.65] group-focus-within:-translate-y-[125%] ${
          hasInput ? "!opacity-100 scale-[0.65] -translate-y-[125%] " : ""
        }`}
      >
        {input.label || input.placeholder}
      </label>
      <input
        type={input.inputType}
        name={input.name}
        id={inputId}
        required
        autoComplete="off"
        defaultValue={value}
        onChange={handleInputChange}
        className="outline-none"
      />
    </div>
  );
}
